import {WorkflowInstanceStepEditModel} from "./workflow-instance-step-edit.model";
import {WorkflowStep} from "../../../enums/WorkflowStep";
import {BatchModel} from "../../batch/batch.model";
import {WorkFlowStepTargetPcrModel} from "../work-flow-step-target-pcr.model";

export class WorkflowInstanceStepTargetPcrEditModel extends WorkflowInstanceStepEditModel {

  batches: BatchModel[];

  static initFromStep(step: WorkFlowStepTargetPcrModel): WorkflowInstanceStepEditModel {
    const ret = new WorkflowInstanceStepTargetPcrEditModel();
    ret.workflowStep = WorkflowStep.NORMALIZATION;
    ret.workflowInstanceStepId = step.id;
    ret.batches = step.batches;
    return ret;
  }

}
